import { render, staticRenderFns } from "./ControleEditarMarcacoes.vue?vue&type=template&id=96c6fa78&"
import script from "./ControleEditarMarcacoes.vue?vue&type=script&lang=js&"
export * from "./ControleEditarMarcacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports